import React from "react";
import {OntSerialNumberInput} from "./OntSerialNumberInput";
import {OntMacAddressInput} from "./OntMacAddressInput";
import {filterErrorForField} from "../../../../utils/ErrorUtils";

export const OntData = ({technicalData, onChange, startBarcodeScanning, errors}) => {
  return (<>
    <h6 className="text-xs font-bold text-gray-600 uppercase">ONT</h6>
    <div className="space-y-2">
      <OntSerialNumberInput
        technicalData={technicalData}
        onChange={onChange}
        startBarcodeScanning={startBarcodeScanning}
      />
      <OntMacAddressInput
        technicalData={technicalData}
        onChange={onChange}
        startBarcodeScanning={startBarcodeScanning}
        errors={filterErrorForField(errors, 'technicalData.ont.mac_address')}
      />
    </div>
  </>);
}